import { Answer, Question, Response } from "../types";

type Choice<T, S = unknown> = {
  statement: S;
  value: T;
};

export function isMultiChoiceQuestion(
  question: Question<unknown>
): question is MultiChoiceQuestion<unknown, unknown> {
  return question.type === "multichoice";
}

export function isMultiChoiceResponse(
  response: Response
): response is MultiChoiceResponse {
  return response.type === "multichoice";
}

export class MultiChoiceQuestion<T, S> implements Question<T[]> {
  type = "multichoice" as const;

  statement: S;

  choices: Choice<T, S>[];

  constructor(statement: S, choices: [S, T][]) {
    this.statement = statement;
    this.choices = choices.map(([statement, value]) => ({ statement, value }));
  }

  getValue(answer: Answer) {
    if (!isMultiChoiceResponse(answer.response)) {
      throw new Error("Expected MultiChoiceResponse");
    }

    const { choiceIndices } = answer.response;
    return choiceIndices.map((index) => {
      return this.choices[index].value;
    });
  }
}

export type MultiChoiceResponse = {
  type: "multichoice";
  choiceIndices: number[];
};

export function createMultiChoiceAnswer(
  indices: number[]
): Answer<MultiChoiceResponse> {
  return {
    response: {
      type: "multichoice",
      choiceIndices: indices,
    },
  };
}
